import React, { FC, memo } from 'react'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { VideoPreview } from '@ucheba/ui/components/VideoPreview/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import Image from 'next/image'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Description } from '@ucheba/ui/components/Description/desktop'
import styled from 'styled-components'
import { Button } from '@ucheba/ui/components/Button/desktop'
import SC from '../base/styles'
import { ITeacherCardItem } from '../types'

const {
  VideoPreviewExperienceText,
  VideoPreviewOverlay,
  VideoPreviewAverageScoreText,
  TeachersListItem: TeachersListItemSC,
  StyledGridCol,
  StyledBox: StyledBoxSC,
} = SC

const StyledBox = styled(StyledBoxSC)`
  display: flex;
  flex-direction: column;
`

const TeachersListItem = styled(TeachersListItemSC)`
  height: 100%;
`

const BottomBlock = styled.div`
  margin-top: 16px;
  flex: 1;
  display: flex;
  align-items: flex-end;
`

const TeacherCardVertical: FC<ITeacherCardItem> = (props) => {
  const {
    name,
    description,
    subjects,
    buttonText,
    onClick,
    href,
    previewImage,
    experience,
    avgScore,
    width = '100%',
    withSubjects = true,
  } = props

  const VideoBlock = (
    <VideoPreview
      size='small'
      imgUrl={previewImage}
      Overlay={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <VideoPreviewOverlay as={Box} spacing={['small', 'large']}>
          <VideoPreviewExperienceText>
            {experience && experience.scoreText && experience.scoreText && (
              <>
                <Heading
                  as='div'
                  h3={experience.scoreText}
                  color='gold'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='gold'>
                  {experience.text}
                </Text>
              </>
            )}
          </VideoPreviewExperienceText>

          <VideoPreviewAverageScoreText>
            {avgScore && avgScore.scoreText && avgScore.text && (
              <>
                <Heading
                  as='div'
                  h3={avgScore.scoreText}
                  color='rose'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='rose'>
                  {avgScore.text}
                </Text>
              </>
            )}
          </VideoPreviewAverageScoreText>
        </VideoPreviewOverlay>
      }
    />
  )

  const VideoBlockWithoutIcon = (
    <VideoPreview
      size='small'
      imgUrl={previewImage}
      withIcon={false}
      Overlay={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <VideoPreviewOverlay as={Box} spacing={['small', 'large']}>
          <VideoPreviewExperienceText>
            {experience && experience.scoreText && experience.scoreText && (
              <>
                <Heading
                  as='div'
                  h3={experience.scoreText}
                  color='gold'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='gold'>
                  {experience.text}
                </Text>
              </>
            )}
          </VideoPreviewExperienceText>

          <VideoPreviewAverageScoreText>
            {avgScore && avgScore.scoreText && avgScore.text && (
              <>
                <Heading
                  as='div'
                  h3={avgScore.scoreText}
                  color='rose'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='rose'>
                  {avgScore.text}
                </Text>
              </>
            )}
          </VideoPreviewAverageScoreText>
        </VideoPreviewOverlay>
      }
    />
  )

  return (
    <TeachersListItem as={Box} spacing='null' width={width}>
      {href ? VideoBlock : VideoBlockWithoutIcon}

      <StyledBox as={Box} color='white' radius='null'>
        {withSubjects && (
          <>
            <Grid spacing='xsmall'>
              {subjects.map((subject, subjectIndex) => (
                <GridCol width='auto' key={subjectIndex}>
                  <Grid spacing='xxsmall'>
                    <StyledGridCol as={GridCol} width='auto'>
                      <Image
                        src={`https://www.ucheba.ru${subject.iconUrl || ''}`}
                        width={20}
                        height={20}
                        alt=''
                      />
                    </StyledGridCol>

                    <GridCol width='auto'>
                      <Text firstLetterUppercase>{subject.name}</Text>
                    </GridCol>
                  </Grid>
                </GridCol>
              ))}
            </Grid>

            <Spacing spacing='usmall' />
          </>
        )}

        <Heading h2={name} as='div' spacing='xxsmall' />

        <Description description={description} />

        {buttonText && (
          <BottomBlock>
            <Button color='orange' block onClick={onClick}>
              {buttonText}
            </Button>
          </BottomBlock>
        )}
      </StyledBox>
    </TeachersListItem>
  )
}

export default memo(TeacherCardVertical)
